var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6C7.875 6.49728 7.67746 6.97419 7.32583 7.32583C6.97419 7.67746 6.49728 7.875 6 7.875C5.50272 7.875 5.02581 7.67746 4.67417 7.32583C4.32254 6.97419 4.125 6.49728 4.125 6C4.125 5.50272 4.32254 5.02581 4.67417 4.67417C5.02581 4.32254 5.50272 4.125 6 4.125C6.49728 4.125 6.97419 4.32254 7.32583 4.67417C7.67746 5.02581 7.875 5.50272 7.875 6Z",
    fill: "#5E4DE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 6 2.25 1.875 6 1.875C9.75 1.875 12 6 12 6C12 6 9.75 10.125 6 10.125C2.25 10.125 0 6 0 6ZM6 8.625C6.69619 8.625 7.36387 8.34844 7.85616 7.85616C8.34844 7.36387 8.625 6.69619 8.625 6C8.625 5.30381 8.34844 4.63613 7.85616 4.14384C7.36387 3.65156 6.69619 3.375 6 3.375C5.30381 3.375 4.63613 3.65156 4.14384 4.14384C3.65156 4.63613 3.375 5.30381 3.375 6C3.375 6.69619 3.65156 7.36387 4.14384 7.85616C4.63613 8.34844 5.30381 8.625 6 8.625Z",
    fill: "#5E4DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.19d14cbd2c9fa096d50998770d0c9bb9.svg";
export { ForwardRef as ReactComponent };